import React from "react";
import CheckYourEmail from "../components/auth/CheckYourEmail";

export default function ConfirmReset() {
  return <CheckYourEmail />;
}
